module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-fa2772.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/glyphicons-halflings-regular.woff
 ** module id = 512
 ** module chunks = 2
 **/